export default __webpack_public_path__ + "static/media/bsgMatrix.cb727166.jpg";